<template>
  <div class="adminOrderPrintPreview">
    <div class="is-hidden-print-view">
      <div class="PrintTools">
        <div class="ToolbarRight">
          <el-button @click="printOrderDetail()">印刷</el-button>
          <el-button @click="goBackOrderDetail()">戻る</el-button>
        </div>
      </div>
    </div>
    <div class="print-view">
      <div class="OrderPreview">
        <section
          v-for="(order, orderIndex) in printOrders"
          :key="`print-order-${order.id || orderIndex}`"
          class="A4PortraitBox"
        >
          <!-- お位牌文字原稿（内部用） -->
          <template v-for="(manuscript, index) in 2">
            <div
              :key="`manuscript-page-${index}`"
              class="print_pages manuscript_page"
            >
              <div class="page-number">
                注文情報ページ{{ toCircledNumber(orderIndex + 1) }}
              </div>
              <div class="leftMargin">
                <p class="previewTitle adjust">
                  お位牌文字原稿（内部用）
                </p>
                <p class="orderNumber">
                  <small v-if="order.orderNumber">
                    {{ formatOrderNumber(order) }}
                  </small>
                </p>
                <div class="table">
                  <div class="container">
                    <div class="row">
                      <div class="col th">御芳名</div>

                      <div class="col td">
                        <span v-if="order.customer && order.customer.name">
                          {{ order.customer.name }} 様
                        </span>
                      </div>

                      <div class="col th">顧客番号</div>
                      <div class="col td">
                        <span v-if="order.customer">
                          {{ order.customer.customerNumber || "" }}
                        </span>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col th">店舗</div>
                      <div class="col td" style="width: 20%">
                        <span v-if="order.clientGroup && order.clientGroup.id">
                          {{ order.clientGroup ? order.clientGroup.id : "" }}
                        </span>
                      </div>

                      <div class="col td">
                        <span v-if="order.clientGroup && order.clientGroup.name">
                          {{ order.clientGroup ? order.clientGroup.name : "" }}
                        </span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col th">支店</div>
                      <div class="col td" style="width: 20%">
                        <span
                          v-if="
                            order.deliveryDestination &&
                            order.deliveryDestination.id
                          "
                        >
                          {{
                            order.deliveryDestination
                              ? order.deliveryDestination.id
                              : ""
                          }}
                        </span>
                      </div>
                      <div class="col td">
                        <span
                          v-if="
                            order.deliveryDestination &&
                            order.deliveryDestination.name
                          "
                        >
                          {{
                            order.deliveryDestination
                              ? order.deliveryDestination.name
                              : ""
                          }}
                        </span>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col th">商品名</div>
                      <div class="col td">
                        <span
                          v-if="
                            order.detail &&
                              order.detail.product &&
                              displayProductName(order)
                          "
                        >
                          {{ displayProductName(order) }}
                        </span>
                      </div>

                      <div class="col th">寸法</div>
                      <div class="col td">
                        <span v-if="order.detail && displaySize(order)">
                          {{ displaySize(order) }}
                        </span>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col th">彫書の種類</div>
                      <div class="col td">
                        {{ typographyPrintType(order) }}
                      </div>

                      <div class="col th">書体</div>
                      <div class="col td">
                        {{ typographyFontName(order) }}
                      </div>
                    </div>

                    <div class="row">
                      <div class="col th">ご契約日</div>
                      <div class="col td">
                        {{ getContractDate(order) }}
                      </div>

                      <div class="col th">引渡予定日</div>
                      <div class="col td">
                        {{ getDeliveryDate(order) }}
                      </div>
                    </div>

                    <div class="row">
                      <div class="col th">備考</div>
                      <div class="col td">
                        <span
                          v-if="order.customer && order.customer.note"
                          v-html="$sanitize(order.customer.note.replace(/\n/g, '<br/>'))"
                        />
                      </div>
                    </div>

                    <div class="row">
                      <div class="col th">希望納期</div>
                      <div class="col td">
                        {{ getExpectedShippingDate(order) }}
                      </div>
                    </div>

                    <!-- ファイルへのリンクを追加（画像以外） -->
                    <div class="row">
                      <div class="col th bottom">ファイル</div>
                      <div class="col td bottom">
                        <template v-if="order.detail && order.detail.attachments">
                          <template v-for="(attachment, index) in order.detail.attachments">
                            <AttachmentResolver
                              :key="`attachment-${index}`"
                              :src="attachment"
                            />
                          </template>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 自由項目 -->
                <!-- <div
                  v-if="order.customFieldInformation && order.customFieldInformation.length"
                  class="table"
                >
                  <div class="container">
                    <div
                      v-for="(item, index) in order.customFieldInformation"
                      class="row"
                      :key="`customField-${item[0]}-${index}`"
                    >
                      <div
                        class="col th"
                        :class="{
                          bottom: isEndRow(index),
                        }"
                      >{{ item[0] }}</div>
                      <div
                        class="col td"
                        :class="{
                          bottom: isEndRow(index),
                        }"
                      >{{ item[1] }}</div>
                    </div>
                  </div>
                </div> -->

                <div class="container-for-tablet-preview flex center">
                  <div class="box tablet-preview">
                    <TabletPreview
                      v-if="order.fontColors"
                      :order="order"
                      :frontColor="order.fontColors[1]"
                      :backColor="order.fontColors[0]"
                    />
                  </div>
                </div>

                <div
                  class="container-for-stamp flex center"
                  :class="stampColor(order)"
                >
                  <div class="box grow" />

                  <div class="box stamp">
                    <h3 class="stamp-typography">
                      {{ typographyPrintType(order) }}/{{ typographyFontShortName(order) }}
                    </h3>

                    <strong class="stamp-info">
                      {{ formatOrderNumber(order) }}

                      <span class="stamp-info-spacer" />

                      {{ getShippingDateFromKikanDB(order) }}
                    </strong>
                  </div>
                </div>

              </div>
            </div>
          </template>

          <div
            v-for="(layoutImage, layoutIndex) in getApprovedLayoutImages(order)"
            :key="`approved-layout-${order.id || orderIndex}-${layoutImage.id || layoutIndex}`"
            class="print_page approved-layout-print-page"
          >
            <div class="page-number">
              校了レイアウトページ{{ toCircledNumber(orderIndex + 1) }}
            </div>
            <div class="approved-layout-print-page__inner">
              <img
                v-if="getApprovedLayoutImageUrl(layoutImage)"
                :src="getApprovedLayoutImageUrl(layoutImage)"
                class="approved-layout-print-page__image"
              >
            </div>
          </div>

        </section>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapState } from "vuex";

import Order from "@/entities/order.entity";
import SECT_LIST from "@/const/sectList";

import TabletPreview from "@/components/Common/TabletPreview.vue";

import OrderUsecase from "@/usecases/order.usecase";
import UserUsecase from "@/usecases/user.usecase";
import FileUsecase from "@/usecases/file.usecase";
import VariantCharacterUsecase from "@/usecases/variantCharacter.usecase";

// import { apiErrorHandler } from "@/services/apiErrorHandler";

const DATE_FORMAT = "YYYY/M/D"; // "YYYY年M月D日";

export default {
  components: {
    TabletPreview,
  },
  data () {
    return {
      order: {},
      basicInformations: [],
      customerItems: {
        customer: {
          name: "",
          zipcode: "",
          address: "",
          tel: "",
          sect: "",
          familyTemple: "",
          buddhistMemorialDate: "",
          note: "",
        },
      },
      hasMessages: false,
      users: [],
      userAssignDialogVisible: false,
      assignName: "",
      selectUserName: "",
      selectUserId: "",
      orderDetailId: null,
      editDialog: false,
      isDisableLayout: false,
      isDisableOrder: false,
      isDisableShipped: false,
      layoutDialogVisible: false,
      dateInputDialogVisible: false,
      confirmOrderDialogVisible: false,
      shippedDialogVisible: false,
      fixedShippingDate: "",
      orderStatus: "",
      selectedValue: "対応を選択",
      acceptOrderDialogVisible: false,
      cancelOrderDialogVisible: false,
      isLayoutVisible: false,
      isOrderVisible: false,
      isShippedVisible: false,
      isArrow1Visible: false,
      isArrow2Visible: false,
      isNeededLayoutReply: "",
      points: [],
      buddhistNames: ["", ""],
      secularNames: ["", ""],
      isShowRodanSetValues: false,
      approvedLayoutImageUrlMap: {},
      shippingDateFromKikanDB: "",
    };
  },
  title () {
    return `入日記No.${this.$route.params.orderNo}`;
  },
  async created () {
    window.scrollTo(0, 0);
    this.syncOrder();
    this.getPointsImages();
  },
  mounted () {},
  watch: {
    order: {
      deep: true,
      handler: function () {
        this.getPointsImages();
      },
    },
  },
  computed: {
    ...mapState({
      clientGroup: state => state.user.clientsGroup,
    }),
    isValidOrderAvailable () {
      return this.order instanceof Order;
    },
    printOrders () {
      if (!this.order || !this.order.id) {
        return [];
      }
      const parentOrder = this.order instanceof Order
        ? this.order
        : Order.fromJson(this.order);
      const childOrders = Array.isArray(this.order.childOrders)
        ? this.order.childOrders.map(order =>
          order instanceof Order ? order : Order.fromJson(order)
        )
        : [];
      return [parentOrder, ...childOrders];
    },
  },
  methods: {
    onHasMessagesEvent (hasMessages) {
      this.hasMessages = hasMessages;
    },
    isAzukariIhaiProduct (order) {
      const { detail } = order || {};
      return (
        detail &&
        detail.product &&
        detail.product.category &&
        detail.product.category.id === "99000"
      );
    },
    displayProductName (order) {
      const { detail } = order || {};
      if (!detail || !detail.product) return "";
      if (this.isAzukariIhaiProduct(order) && detail.azukariProductName) {
        return `お預かり ${detail.azukariProductName}`;
      }
      return detail.product.name || "";
    },
    displaySize (order) {
      const { detail } = order || {};
      if (!detail) return "";
      if (this.isAzukariIhaiProduct(order) && detail.azukariProductSize != null && detail.azukariProductSize !== "") {
        return detail.azukariProductSize;
      }
      if (detail.productVariation && detail.productVariation.size) {
        return detail.productVariation.size;
      }
      return "";
    },
    formatOrderNumber (order) {
      const orderNumber = order && order.orderNumber ? order.orderNumber : "";
      return orderNumber ? "6" + orderNumber : orderNumber;
    },
    typographyPrintType (order) {
      const detail = order && order.detail;
      if (detail && detail.typography && detail.typography.printType) {
        return detail.typography.printType === "CARVE" ? "戒名彫" : "戒名書";
      }
      return "";
    },
    typographyFontName (order) {
      const detail = order && order.detail;
      if (detail && detail.typography && detail.typography.font) {
        const fontName = detail.typography.font === "標準書体"
          ? "楷書体"
          : detail.typography.font;
        if (fontName === "合掌体") return "機械書";
        if (fontName === "機械書手彫風書体") return "機械書(手彫風書体)";
        return fontName;
      }
      return "";
    },
    typographyFontShortName (order) {
      const detail = order && order.detail;
      if (detail && detail.typography && detail.typography.font) {
        const { font } = detail.typography;
        if (font === "標準書体") return "楷書体";
        if (font === "SK書体") return "SK書";
        if (font === "手彫り風書体") return "手彫風";
        if (font === "機械書手彫風書体") return "機械書(手彫風書体)";
        return font;
      }
      return "";
    },
    stampColor (order) {
      const detail = order && order.detail;
      const clientGroup =
        (order && order.clientGroup) ||
        (order && order.client && order.client.clientGroup) ||
        (this.order && this.order.clientGroup) ||
        (this.order && this.order.client && this.order.client.clientGroup);
      if (
        detail &&
        detail.typography &&
        detail.typography.font &&
        detail.typography.printType &&
        clientGroup &&
        clientGroup.region
      ) {
        const fontShortName = this.typographyFontShortName(order);
        const { printType } = detail.typography;
        const { region } = clientGroup;
        if (region === "WEST") {
          return printType === "CARVE" ? ["blue"] : ["green"];
        }
        if (region === "EAST") {
          if (printType !== "CARVE") {
            if (fontShortName === "機械書(手彫風書体)") return ["lime"];
            return ["green"];
          }
          if (fontShortName === "楷書体") return ["red"];
          if (fontShortName === "手彫風") return ["orange"];
        }
      }
      return [];
    },
    async resolvePrimaryOrder (order) {
      const parentOrderId =
        order && order.parentOrder && order.parentOrder.id
          ? order.parentOrder.id
          : null;
      if (!order || !parentOrderId) {
        return order;
      }
      const parentOrder = await usecase.order.getOrder({ orderId: parentOrderId });
      return parentOrder || order;
    },
    async syncShippingDateMap () {
      const shippingDateMap = {};
      const orders = this.printOrders;
      await Promise.all(
        orders.map(async (order) => {
          try {
            const res = await usecase.order.getKikanOrderDetail({ orderId: order.id });
            const kikanOrderDetail = res && res.data ? res.data.kikanOrderDetail : null;
            shippingDateMap[order.id] = kikanOrderDetail ? kikanOrderDetail.shippingDate : "";
          } catch (err) {
            shippingDateMap[order.id] = "";
          }
        })
      );
      this.shippingDateFromKikanDB = shippingDateMap;
    },
    async syncApprovedLayoutImageUrlMap () {
      const map = {};
      const orders = this.printOrders;
      for (const order of orders) {
        const approvedLayoutImages = this.getApprovedLayoutImages(order);
        for (const layoutImage of approvedLayoutImages) {
          if (!layoutImage.imageKey || map[layoutImage.imageKey]) {
            continue;
          }
          try {
            map[layoutImage.imageKey] = await usecase.file.fetchURL(layoutImage.imageKey);
          } catch (err) {
            console.error("Failed to fetch approved layout image URL", err);
          }
        }
      }
      this.approvedLayoutImageUrlMap = map;
    },
    getApprovedLayoutImages (order) {
      if (!order || !Array.isArray(order.layoutImages)) {
        return [];
      }
      return order.layoutImages.filter(layoutImage => {
        return layoutImage && layoutImage.isApproved && layoutImage.imageKey;
      });
    },
    getApprovedLayoutImageUrl (layoutImage) {
      if (!layoutImage || !layoutImage.imageKey) {
        return "";
      }
      return this.approvedLayoutImageUrlMap[layoutImage.imageKey] || "";
    },
    toCircledNumber (n) {
      const circled = ["\u2460", "\u2461", "\u2462", "\u2463", "\u2464", "\u2465", "\u2466", "\u2467", "\u2468", "\u2469"];
      if (n >= 1 && n <= 10) return circled[n - 1];
      return `(${n})`;
    },
    getPointsImages () {
      if (!this.order.itaijiPoints) {
        return;
      }
      this.points = [];
      this.order.itaijiPoints.map(key => {
        return usecase.file.fetchURL(key).then(url => {
          this.points.push(url);
        });
      });
    },
    async syncOrder () {
      if (!this.$route.params.id) return;
      const orderId = this.$route.params.id;
      this.orderDetailId = orderId;
      try {
        const loadedOrder = await usecase.order.getOrder({ orderId });
        this.order = await this.resolvePrimaryOrder(loadedOrder);
        // 宗派でその他が選択されている場合のチェック
        let count = SECT_LIST.sects.length;
        // 取得した宗派リストと客の宗派を比較
        for (let i = 0; i < count; i++) {
          if (this.order.customer.sect === "その他") {
            this.sectIsEtc = true;
            this.sect = "その他";
            break;
          } else if (SECT_LIST.sects[i] === this.order.customer.sect) {
            this.sectIsEtc = false;
            this.sect = this.order.customer.sect;
            break;
          } else {
            this.sectIsEtc = true;
            this.sect = "その他";
          }
        }
        if (this.order) {
          this.fixedShippingDate = this.order.detail.fixedShippingDate;
          this.orderStatus = this.order.status.code;
          this.isNeededLayoutReply = this.order.detail.isNeededLayoutReply;
          this.getButtonsAction();
          this.getBasicInformations(this.order);
          // this.getProductInformations(this.order);
          if (this.order.staff !== null) {
            this.assignName = this.order.staff.name;
          }
          const query = {
            q: { role: "ADMIN" },
          };
          this.users = await usecase.user.getAdminUsers(query);
        }
      } catch (err) {
        // apiErrorHandler(this, err);
      }

      await this.syncShippingDateMap();
      await this.syncApprovedLayoutImageUrlMap();

      try {
        this.buddhistNames = await this.getStingArrayWithVariantCharacterCode(
          "buddhistName"
        );
        this.secularNames = await this.getStingArrayWithVariantCharacterCode(
          "secularName"
        );
        this.dateOfDeath = await this.getStingArrayWithVariantCharacterCode(
          "dateOfDeath"
        );
        this.ageAtDeath = await this.getStingArrayWithVariantCharacterCode(
          "ageAtDeath"
        );
        this.underCharacters = await this.getStingArrayWithVariantCharacterCode(
          "underCharacters"
        );
        this.secularNameSuffix = await this.getStingArrayWithVariantCharacterCode(
          "secularNameSuffix"
        );
        this.ageUnitCharacter = await this.getStingArrayWithVariantCharacterCode(
          "ageUnitCharacter"
        );
        this.ageAtDeathPrefix = await this.getStingArrayWithVariantCharacterCode(
          "ageAtDeathPrefix"
        );
        this.commonSecularNamePrefix = await this.getStringWithVariantCharacterCode(
          this.order.detail.secularNamePrefix
        );
        this.commonAgeAtDeathPrefix = await this.getStringWithVariantCharacterCode(
          this.order.detail.ageAtDeathPrefix
        );
        this.commonAgeUnitCharacter = await this.getStringWithVariantCharacterCode(
          this.order.detail.ageUnitCharacter
        );
        this.commonDiedCharacter = await this.getStringWithVariantCharacterCode(
          this.order.detail.diedCharacter
        );
        this.commonUnderCharacters = await this.getStringWithVariantCharacterCode(
          this.order.detail.underCharactersPlacement
        );
      } catch (err) {
        // apiErrorHandler(this, err);
        // console.log(err);
      } finally {
        this.isShowRodanSetValues = true;
      }
    },
    /* to span column for remark */
    arraySpanMethod ({ rowIndex, columnIndex }) {
      let rolNo =
        this.order.statement && this.order.statement.items.length
          ? this.order.statement.items.length
          : "";
      if (rowIndex === rolNo) {
        if (columnIndex === 5) {
          return [1, 3];
        }
      }
    },
    /* to assign user */
    async assignUser () {
      const orderId = this.$route.params.id;
      const staffId = this.selectUserId;
      const staffName = this.selectUserName;
      const updateStaff = {
        orderId,
        staffId,
      };
      this.userAssignDialogVisible = false;
      await usecase.order.orderAssignStaff(updateStaff);
      this.assignName = staffName;
    },
    goBackOrderDetail () {
      const { $router } = this;
      const id = this.$route.params.id;
      $router.push(`/admin/orders/${id}`);
    },
    printOrderDetail () {
      // this.$root.hideSideBar = true;
      var newstr = document.getElementsByClassName("OrderPreview")[0].innerHTML;
      document.body.innerHTML = newstr;
      window.print();
      // Reload the page to refresh the data
      // this.$root.hideSideBar = false;
      window.location.reload();
    },
    getColumnsInformationValue (itemName, num) {
      if (!this.order.columnsInformation2) return "";
      const items = this.order.columnsInformation2[num];
      let result = "";
      if (items) {
        this.order.columnsInformation2[num].forEach(value => {
          if (value[0] === itemName) {
            result = value[1];
          }
        });
      }
      return result;
    },
    getDetailInformationValue (ItemName) {
      if (!this.order.detailInformation2) return "";
      const items = this.order.detailInformation2;
      let result = "";
      if (items) {
        this.order.detailInformation2.forEach(value => {
          if (value[0] === ItemName) {
            result = value[1];
          }
        });
      }
      return result;
    },
    getDateOfDeathYear (num) {
      const datesOfDeath = this.getColumnsInformationValue("没年月日", num);
      if (datesOfDeath) {
        const index = datesOfDeath.indexOf("年");
        if (index === 0) return "";
        return datesOfDeath.substr(0, index + 1);
      }
      return "";
    },
    getDateOfDeathDate (num) {
      const datesOfDeath = this.getColumnsInformationValue("没年月日", num);
      if (datesOfDeath) {
        const index = datesOfDeath.indexOf("年");
        if (index === 0) return "";
        return datesOfDeath.slice(index + 1);
      }
      return "";
    },

    /**
     * ご契約日
     * @return  {[type]}  [return description]
     */
    getContractDate (order) {
      if (
        order &&
        order.detail &&
        order.detail.contractDate
      ) {
        return moment(order.detail.contractDate).format(DATE_FORMAT);
      }

      return "";

      // return moment.unix(this.order.orderedAt).format(DATE_FORMAT);
    },

    /**
     * 引渡予定日
     * @return  {[type]}  [return description]
     */
    getDeliveryDate (order) {
      if (
        order &&
        order.detail &&
        order.detail.deliveryDate
      ) {
        return moment(order.detail.deliveryDate).format(DATE_FORMAT);
      }

      return "";
    },

    /**
     * 四十九日法要日
     * @return  {[type]}  [return description]
     */
    getFortyNinthMemorialServiceDate () {
      if (
        this.order.detail &&
        this.order.detail.fortyNinthMemorialServiceDate
      ) {
        return moment(this.order.detail.fortyNinthMemorialServiceDate).format(DATE_FORMAT);
      }

      return "";
    },

    /**
     * 希望納期
     * @return  {[type]}  [return description]
     */
    getExpectedShippingDate (order) {
      if (
        order &&
        order.detail &&
        order.detail.expectedShippingDate
      ) {
        return moment(order.detail.expectedShippingDate).format(DATE_FORMAT);
      }

      return "";
    },

    /**
     * 出荷日 (基幹DB)
     * @return  {[type]}  [return description]
     */
    getShippingDateFromKikanDB (order) {
      const shippingDate = order && order.id && this.shippingDateFromKikanDB
        ? this.shippingDateFromKikanDB[order.id]
        : "";
      if (shippingDate) {
        return moment(shippingDate).format("M/D") + "出荷";
      }

      return "出荷日未定";
    },

    /**
     * [Deprecated] 出荷日
     * @return  {[type]}  [return description]
     */
    getFixedShippingDate () {
      if (
        this.order.detail &&
        this.order.detail.fixedShippingDate
      ) {
        const { fixedShippingDate } = this.order.detail;

        return fixedShippingDate === ""
          ? "未出荷"
          : moment(this.order.detail.fixedShippingDate).format("M/D") + "出荷";
      }

      return "出荷日未定";
    },

    async getStingArrayWithVariantCharacterCode (item) {
      const results = [];
      if (
        !(
          this.order.detail.columns &&
          this.order.detail.columns.length &&
          this.order.detail.columns[0] &&
          this.order.detail.columns[0][item]
        )
      ) {
        return ["", ""];
      }

      if (this.order.detail.columns) {
        for (let i = 0; i < this.order.detail.columns.length; i++) {
          if (this.order.detail.columns[i][item]) {
            const stringDatas = this.order.detail.columns[i][item];
            const value = await this.getStringWithVariantCharacterCode(
              stringDatas
            );
            results.push(value);
          } else {
            results.push("");
          }
        }
      }
      return results;
    },
    async getStringWithVariantCharacterCode (item) {
      let result = "";
      if (!item) return "";
      if (
        this.order.detail &&
        this.order.detail.columns &&
        item &&
        item.length
      ) {
        const valueDatas = item;
        const resultCharacters = [];
        for (const characterData of valueDatas) {
          if (characterData.variantCharacterId) {
            const variantCharacterRecord = await usecase.variantCharacter.getVariantCharacter(
              {
                id: characterData.variantCharacterId,
              }
            );
            if (variantCharacterRecord) {
              resultCharacters.push(variantCharacterRecord.inputCode);
            }
          } else {
            resultCharacters.push(characterData.character);
          }
        }
        result = resultCharacters.join("");
      }
      return result;
    },
    async getBuddhistNameWithVariantCharacterCode () {
      const results = [];
      if (this.order.detail && this.order.detail.columns) {
        for (let i = 0; i < this.order.detail.columns.length; i++) {
          const buddhistNameDatas = this.order.detail.columns[i].buddhistName
            ._data;
          const resultCharacters = [];
          for (const characterData of buddhistNameDatas) {
            if (characterData.variantCharacterId !== null) {
              const variantCharacterRecord = await usecase.variantCharacter.getVariantCharacter(
                {
                  id: characterData.variantCharacterId,
                }
              );
              if (variantCharacterRecord) {
                resultCharacters.push(variantCharacterRecord.inputCode);
              }
            } else {
              resultCharacters.push(characterData.character);
            }
          }
          results.push(resultCharacters.join(""));
        }
      }
      return results;
    },
    async getSecularNameWithVariantCharacterCode () {
      const results = [];
      if (this.order.detail && this.order.detail.columns) {
        for (let i = 0; i < this.order.detail.columns.length; i++) {
          const secularNameDatas = this.order.detail.columns[i].secularName
            ._data;
          const resultCharacters = [];
          for (const characterData of secularNameDatas) {
            if (characterData.variantCharacterId !== null) {
              const variantCharacterRecord = await usecase.variantCharacter.getVariantCharacter(
                {
                  id: characterData.variantCharacterId,
                }
              );
              if (variantCharacterRecord) {
                resultCharacters.push(variantCharacterRecord.inputCode);
              }
            } else {
              resultCharacters.push(characterData.character);
            }
          }
          results.push(resultCharacters.join(""));
        }
      }
      return results;
    },

    /**
     * [isEndRow description]
     * @param   {[type]}  index  [index description]
     * @return  {[type]}         [return description]
     */
    isEndRow (index) {
      const endRowIndex = this.order.customFieldInformation.length - 1;

      return index === endRowIndex;
    },

    /**
     * [isAttachmentExpectImages description]
     * @param   {[type]}  attachment  [attachment description]
     * @return  {[type]}              [return description]
     */
    isAttachmentExpectImages (attachment) {
      const patterns = ["jpg", "jpeg", "png", "bmp"];
      const isImage = patterns.find(pattern => {
        // リンク先のファイル拡張子を取得（小文字に統一）
        const extension = attachment.split(".").slice(-1)[0].toLowerCase();

        return extension.indexOf(pattern) >= 0;
      });

      return !isImage;
    },

    /**
     * [isAttachmentExpectDocuments description]
     * @param   {[type]}  attachment  [attachment description]
     * @return  {[type]}              [return description]
     */
    isAttachmentExpectDocuments (attachment) {
      const patterns = ["doc", "xls", "ppt", "docx", "xlsx", "pptx", "pdf", "txt"];
      const isDocument = patterns.find(pattern => {
        // リンク先のファイル拡張子を取得（小文字に統一）
        const extension = attachment.split(".").slice(-1)[0].toLowerCase();

        return extension.indexOf(pattern) >= 0;
      });

      return !isDocument;
    },

    /**
     * [fetchAttachmentsExpectDocuments description]
     * @param   {[type]}  attachments  [attachments description]
     * @return  {[type]}               [return description]
     */
    fetchAttachmentsExpectDocuments (attachments) {
      const attachmentsExpectDocuments = attachments.filter(attachment => {
        return this.isAttachmentExpectDocuments(attachment);
      });

      return attachmentsExpectDocuments;
    },
  },

  /**
   * [beforeCreate description]
   */
  beforeCreate () {
    usecase.file = new FileUsecase();
    usecase.order = new OrderUsecase();
    usecase.user = new UserUsecase();
    usecase.variantCharacter = new VariantCharacterUsecase();
  },

  /**
   * [beforeDestroy description]
   */
  beforeDestroy () {
    Object.keys(usecase).map(key => {
      delete usecase[key];
    });
  },
};

const usecase = {};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.A4Header {
  color: white;
}
.A4PortraitBox + .A4PortraitBox {
  page-break-before: always;
}
.PrintTools {
  display: flex;
  align-items: center;
  text-align: center;
  padding-top: 2rem;
}
AdminOrderChat {
  width: 90% !important;
}
.ToolbarRight {
  flex: 1;
  text-align: right;
  padding-right: 2rem;
}

.leftMargin {
  padding-left: 40px;
}

.Tablet {
  margin: 20pt 0;
  vertical-align: bottom;
  width: 180pt !important;
  height: 260pt !important;
  object-fit: cover !important;
}

.OrderPreview {
  size: A4 portrait !important;
  text-align: center !important;
  margin-left: auto !important;
  margin-right: auto !important;
  padding-left: 0 !important;
}

.Rodan {
  text-align: center !important;
  margin-left: auto !important;
  margin-right: auto !important;
  padding-left: 0 !important;
  width: 200pt !important;
}

.box {
  width: 25%;
  float: right;
  padding-right: 1rem;
  box-sizing: border-box;
}

.order-info {
  font-size: 1.7rem;
  font-weight: bold;
  text-align: center;
  margin-top: 0.5rem;
}

.cover {
  height: 950px;
  position: absolute;
  border: 1px solid red;
  z-index: 1;
}

.cover2 {
  height: 900px;
  position: absolute;
  margin-left: 2px;
  border: 2px solid green;
  z-index: 1;
}

.previewTitle {
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  margin: 0 0 2rem 0;
  height: 20px;

  &.adjust {
    margin: 0 0 1rem 0;
  }
}

.orderNumber {
  width: 520pt;
  margin: 0 auto;
  text-align: right;
}

.product-inline {
  display: inline-block;
}

.TabletPreview {
  align-self: center !important;
  margin-left: auto !important;
  margin-right: auto !important;
  width: 300pt !important;
}

.TabletPreview .Body {
  text-align: center !important;
  margin-left: auto !important;
  margin-right: auto !important;
}

.TabletPreview .Header {
  margin-left: 0 !important;
}

.TabletPreview .Footer {
  margin-left: 1rem !important;
}

.TabletPreview .FrontView {
  text-align: center !important;
  margin-right: 0.5rem !important;
  margin-left: 0 !important;
}

.TabletPreview .BackView {
  text-align: center !important;
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.TabletPreview .productInfo {
  text-align: center !important;
  margin-right: 0.5rem !important;
  margin-left: 0 !important;
}

.productDetail {
  margin: 0 0.3rem 0;
  font-size: 14px;
  font-weight: bold;
}

.container {
  width: 520pt;
  text-align: left;
}

.container-for-tablet-preview,
.container-for-stamp {
  width: 520pt;
  margin: 0 auto;
}

.container-for-tablet-preview {
  break-inside: avoid;

  .tablet-preview {
    width: 328px;
  }
}

.container-for-stamp {
  margin-top: 8px;
  break-inside: avoid;
  overflow: hidden;

  .stamp {
    width: 200pt;
    max-width: 240pt;
    padding: 12px 0 8px;
    border: 2px solid black;
    text-align: center;
    white-space: nowrap;

    &-typography {
      font-size: 20px;
      margin: 0 0 8px;
      line-height: 1.03;
    }

    &-info {
      font-size: 18.5px;

      &-spacer {
        display: inline-block;
        width: 8px;
      }
    }
  }

  &.red {
    $color: #ff0000;

    .stamp {
      border-color: $color;

      &-typography {
        color: $color;
      }
    }
  }

  &.orange {
    $color: #ee7800;

    .stamp {
      border-color: $color;

      &-typography {
        color: $color;
      }
    }
  }

  &.green {
    $color: #00a960;

    .stamp {
      border-color: $color;

      &-typography {
        color: $color;
      }
    }
  }

  &.lime {
    $color: #96ff00;

    .stamp {
      border-color: $color;

      &-typography {
        color: $color;
      }
    }
  }

  &.blue {
    $color: #0075c2;

    .stamp {
      border-color: $color;

      &-typography {
        color: $color;
      }
    }
  }
}

.table {
  width: 520pt;
  align-self: center;
  align-content: center;
  margin: 0.3rem auto !important;
}

.table .row {
  display: table;
  table-layout: fixed;
  border-collapse: collapse;
  width: 100%;
}

.table .row .col.th {
  display: table-cell;
  padding: 0.3rem;
  border: 1px solid black;
  border-bottom: none;
  width: 100pt;
  background-color: lightgray;
  text-align: center;
}

.table .row .col.empty {
  display: table-cell;
  padding: 0.3rem;
  border: none;
  border-bottom: none;
  text-align: center;
}

.table .row .col.td {
  display: table-cell;
  padding: 0.3rem;
  border: 1px solid black;
  border-bottom: none;
  width: auto;
}

.table .row .col.th.bottom {
  display: table-cell;
  padding: 0.3rem;
  border: 1px solid black;
  width: 100pt;
  background-color: lightgray;
  text-align: center;
}

.table .row .col.td.bottom {
  display: table-cell;
  padding: 0.3rem;
  border: 1px solid black;
  width: auto;
}

.print_page {
  position: relative;
}

.print_pages {
  position: relative;
}

.page-number {
  position: absolute;
  top: 8px;
  right: 12px;
  font-size: 13px;
  color: inherit;
  z-index: 10;
}

.approved-layout-print-page {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}

.approved-layout-print-page__inner {
  width: 100%;
  max-width: 760px;
  margin: 0;
}

.approved-layout-print-page__image {
  width: auto;
  max-width: 100%;
  max-height: 90vh;
  object-fit: contain;
}

.print_pages {
  margin: auto 7rem auto 1rem;
}

.print_pages2 {
  margin: auto;
}

.print-view {
  display: block;
}

.for-printing {
  display: none;
}

.not-for-printing {
  display: block;
}

// 原稿の複製
.manuscript_page:nth-child(2) {
  display: none;
}

@media print {
  @page {
    margin: 15mm 1rem 15mm 1rem;
  }

  @page :first {
    margin: 15mm 1rem 15mm 1rem;
  }

  body {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .leftMargin {
    padding-left: 0px;
  }

  .print_page {
    height: 100vh;
    break-after: page;
    page-break-before: always;
  }

  .print_pages {
    size: A4 landscape;
    margin: 15mm 1rem 15mm 1rem;
    page-break-after: always;
  }

  .print-view {
    display: block;
  }

  // 原稿の複製
  .manuscript_page:nth-child(2) {
    display: block;
  }

  .is-hidden-print-view {
    display: block;
  }

  .for-printing {
    display: block;
  }

  .not-for-printing {
    display: none;
  }
}
</style>
